import { useMemo } from 'react';
import { stageGuidedPrompts, stageInfo } from '../../data/notationHotspots';
import type { Stage } from '../../data/notationHotspots';
import './GuidedMode.css';

interface GuidedModeProps {
  currentStage: Stage;
  onSelectHotspot: (id: string) => void;
  exploredIds: Set<string>;
}

export function GuidedMode({ currentStage, onSelectHotspot, exploredIds }: GuidedModeProps) {
  const prompts = stageGuidedPrompts[currentStage] || [];
  const stageColor = stageInfo[currentStage]?.color || '#2493A2';

  const nextPrompt = useMemo(() => {
    return prompts.find(p => !exploredIds.has(p.hotspotId));
  }, [prompts, exploredIds]);

  const exploredCount = prompts.filter(p => exploredIds.has(p.hotspotId)).length;

  if (prompts.length === 0) return null;

  return (
    <div className="guided-mode">
      <div className="guided-mode__progress-row">
        <span className="guided-mode__count">{exploredCount}/{prompts.length}</span>
        <div className="guided-mode__progress-bar">
          <div
            className="guided-mode__progress-fill"
            style={{
              width: `${(exploredCount / prompts.length) * 100}%`,
              background: stageColor
            }}
          />
        </div>
        <span className="guided-mode__hint">explored</span>
      </div>

      {nextPrompt ? (
        <button
          className="guided-mode__explore-btn"
          onClick={() => onSelectHotspot(nextPrompt.hotspotId)}
          style={{ borderColor: stageColor, color: stageColor }}
        >
          <i className="fas fa-search"></i>
          <span>{nextPrompt.prompt}</span>
        </button>
      ) : (
        <div className="guided-mode__complete" style={{ borderColor: stageColor }}>
          <i className="fas fa-check-circle" style={{ color: stageColor }}></i>
          <span>Stage complete!</span>
        </div>
      )}
    </div>
  );
}
